import React from 'react';

import FormActions from '../../../../shared/actions/form';

import InputLabel from '../../widgets/input-label';
import InputHint from '../../widgets/input-hint';
import GroupedInput from './grouped-input';
import CustomGroupedInput from './custom-grouped-input';
import Localization from '../../../../../../../common/edlio-js/models/BackendLocalization';
import BulkEditOptionsModal from '../../../../shared/components/modals/bulk-edit-options-modal';

class InputList extends React.Component {
	componentDidUpdate() {
		// Add two inputs to group on creation of new input group
		if ( !this.props.initialized ) {
			const {
				type,
				fieldsetIndex,
				rowIndex,
				index
			} = this.props;

			FormActions.initializeInputGroup(fieldsetIndex, rowIndex, index, type);
		}
	}

	render() {
		let localization = new Localization(window.edlio.localizations);
		const {
			choices,
			customChoices
		} = this.props;

		const showRemoveOption = choices.length + customChoices.length > 1;

		return (
			<div className='inputs'>
				{
					this.props.choices.map((choice, choiceNumber) => {
						let reference = `grouped_input_${choiceNumber}`;

						return (
							<GroupedInput
                                parentId={this.props.parentId}
								uniqueId={choice.uniqueId}
								ref={reference}
								type={this.props.type}
								fieldsetIndex={this.props.fieldsetIndex}
								rowIndex={this.props.rowIndex}
								index={this.props.index}
								data={choice}
								choiceNumber={choiceNumber}
								removeCallback={this.props.removeCallback}
								showRemoveOption={showRemoveOption}
								key={choice.uniqueId}
							/>
						);
					})
				}
				{
					this.props.customChoices.map((choice, choiceNumber) => {
						let reference = `custom_grouped_input_${choiceNumber}`;

						return (
							<CustomGroupedInput
                                parentId={this.props.parentId}
								uniqueId={choice.uniqueId}
								ref={reference}
								type={this.props.type}
								fieldsetIndex={this.props.fieldsetIndex}
								rowIndex={this.props.rowIndex}
								index={this.props.index}
								data={choice}
								choiceNumber={choiceNumber}
								removeCallback={this.props.removeCustomAnswerCallback}
								showRemoveOption={showRemoveOption}
								key={choice.uniqueId}
							/>
						);
					})
				}
				<aside className='add-to-group'>
					<a className='add' href='javascript:;' onClick={this.props.addCallback}>
						{localization.localize('Add Option')}
					</a>

					<span style={{ display: this.props.customChoices.length === 0 ? null : 'none' }}>
						{localization.localize(' or ')}
						<a className='add other' href='javascript:;' onClick={this.props.addCustomAnswerCallback}>
							{localization.localize('Add "Other"')}
						</a>
					</span>

					{ this.props.bulkEditCallback &&
						<span>
							{' | '}
							<a className='add bulk-edit' href='javascript:;' onClick={this.props.bulkEditCallback}>
								{localization.localize('Bulk Edit')}
							</a>
						</span>
					}
				</aside>
			</div>
		);
	}
}

export default class InputGroup extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			bulkEditVisible: false
		};

		this.openBulkEdit = this.openBulkEdit.bind(this);
		this.closeBulkEdit = this.closeBulkEdit.bind(this);
		this.confirmBulkEdit = this.confirmBulkEdit.bind(this);
	}

	render() {
		const {
			fieldsetIndex,
			rowIndex,
			index,
			usePlaceholderLabel
		} = this.props;

		const {
			type,
			label,
			name,
			hint,
			choices,
			customChoices,
			initialized,
			required,
            uniqueId,
            placeholder
		} = this.props.data;

		return (
			<div className='input-group'>
				<header>
					<InputLabel ref='label' label={label} required={required} placeholder={placeholder} usePlaceholderLabel={usePlaceholderLabel} type={type} />
					<InputHint ref='hint' hint={hint} type={type} />
				</header>
				<InputList
					ref='inputList'
					type={type}
					name={name}
					fieldsetIndex={fieldsetIndex}
					rowIndex={rowIndex}
					index={index}
					choices={choices}
					customChoices={customChoices}
					initialized={initialized}
                    parentId={uniqueId}
					addCallback={this.addOption}
					addCustomAnswerCallback={this.addCustomAnswerField}
					removeCallback={this.removeOption}
					removeCustomAnswerCallback={this.removeCustomAnswerField}
					bulkEditCallback={this.openBulkEdit}
				/>
				<BulkEditOptionsModal
					visible={this.state.bulkEditVisible}
					options={choices.map(choice => choice.label)}
					onClose={this.closeBulkEdit}
					onConfirm={this.confirmBulkEdit}
				/>
			</div>
		);
	}

	// Custom Methods ------------------------------------------------------------

	openBulkEdit() {
		this.setState({ bulkEditVisible: true });
	}

	closeBulkEdit() {
		this.setState({ bulkEditVisible: false });
	}

	confirmBulkEdit(labels) {
		const {
			fieldsetIndex,
			rowIndex,
			index
		} = this.props;

		FormActions.bulkReplaceOptions(fieldsetIndex, rowIndex, index, 'choices', labels, this.props.data.type);
		this.closeBulkEdit();
	}

	/**
	 * @method addOption
	 * render new grouped input (ie. checkbox, radio, etc) when user clicks "Add Option"
	 */
	addOption = (addOtherField) => {
		const {
			type,
			fieldsetIndex,
			rowIndex,
			index
		} = this.props;

		FormActions.addInputToGroup(fieldsetIndex, rowIndex, index, type);
	}

	/**
	 * @method addCustomAnswerField
	 * render new custom grouped input (ie. checkbox, radio, etc) when user clicks "Add Option"
	 */
	addCustomAnswerField = () => {
		const {
			type,
			fieldsetIndex,
			rowIndex,
			index
		} = this.props;

		FormActions.addCustomAnswerFieldToGroup(fieldsetIndex, rowIndex, index, type);
	}

	/**
	 * @method removeOption
	 * remove grouped input (ie. checkbox, radio, etc) when user clicks trash icon
	 */
	removeOption = (choiceNumber) => {
		const {
			fieldsetIndex,
			rowIndex,
			index
		} = this.props;

		setTimeout(() => {
			FormActions.removeInputFromGroup(fieldsetIndex, rowIndex, index, choiceNumber);
		}, 0);
	}

	/**
	 * @method removeCustomAnswerField
	 * remove custom grouped input (ie. checkbox, radio, etc) when user clicks trash icon
	 */
	removeCustomAnswerField = (choiceNumber) => {
		const {
			fieldsetIndex,
			rowIndex,
			index
		} = this.props;

		setTimeout(() => {
			FormActions.removeCustomAnswerFieldFromGroup(fieldsetIndex, rowIndex, index, choiceNumber);
		}, 0);
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/components/form-elements/input-groups/input-group.js